import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.USER};
const path = "/user"


export const sendWhatsappMessage = async (value) => {
    return await axiosInstance(options).post(`${path}/whatsapp-message/send-product-details`,value);
}

export const sendSellerNotification = async (value) => {
    return await axiosInstance(options).post(`${path}/whatsapp-message/send-seller-notification`, value);
}

export const isMobileDevice = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    // Check for mobile device
    return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
}

export const formatPhoneForWhatsapp = (phoneNumber) => {
    if (!phoneNumber) return null;
    
    // Clean: remove all non-digits
    let cleanPhone = phoneNumber.replace(/\D/g, "");
    
    // Add country code (India +91) if missing and number starts with 10 digits
    // Assuming India numbers: if 10 digits and doesn't start with 91
    if (cleanPhone.length === 10 && !cleanPhone.startsWith("91")) {
        cleanPhone = "91" + cleanPhone;
    } else if (cleanPhone.length === 12 && cleanPhone.startsWith("0091")) {
        // Remove leading 00 if present
        cleanPhone = cleanPhone.substring(2);
    }
    
    return cleanPhone;
}

export const generateWhatsappLink = (phoneNumber, message) => {
    if (!phoneNumber) return null;
    
    const formattedPhone = formatPhoneForWhatsapp(phoneNumber);
    if (!formattedPhone) return null;
    
    const encodedMessage = message ? encodeURIComponent(message) : "";
    const textParam = encodedMessage ? `&text=${encodedMessage}` : "";
    const isMobile = isMobileDevice();
    
    if (isMobile) {
        // Mobile: use whatsapp:// for native app, fallback to web link
        return {
            primary: `whatsapp://send?phone=${formattedPhone}${textParam}`,
            fallback: `https://api.whatsapp.com/send?phone=${formattedPhone}${textParam}`
        };
    } else {
        // Desktop: use web.whatsapp.com
        return {
            primary: `https://web.whatsapp.com/send?phone=${formattedPhone}${textParam}`,
            fallback: `https://api.whatsapp.com/send?phone=${formattedPhone}${textParam}`
        };
    }
}

export const openWhatsappChat = (phoneNumber, message) => {
    try {
        const links = generateWhatsappLink(phoneNumber, message);
        if (!links) {
            console.error("Invalid phone number for WhatsApp");
            return false;
        }
        
        console.log("Opening WhatsApp chat...", { phoneNumber, isMobile: isMobileDevice() });
        
        // Try primary link
        const primaryWindow = window.open(links.primary, '_blank');
        
        // If primary link didn't work (mobile native app not installed), fallback to web
        if (!primaryWindow || primaryWindow.closed === undefined) {
            // For mobile, give native app a moment to open
            setTimeout(() => {
                window.open(links.fallback, '_blank');
            }, 1000);
        }
        
        return true;
    } catch (err) {
        console.error("Error opening WhatsApp:", err);
        return false;
    }
}

export const getWhatsappWebhook = async (value) => {
    return await axiosInstance(options).get(`${path}/whatsapp-message/webhook?${value}`);
}

export const postWhatsappWebhook = async (value) => {
    return await axiosInstance(options).post(`${path}/whatsapp-message/webhook?${value}`);
}














